// 3. clusterize groups
/**
 * 
 * @param groups groups of points or other objects
 * @param maxClusters max number of clusters
 * @returns a list of max 100-element clusters of points that are taken from different groups as much as possible
 */
export function clusterize<T>(groups: T[][], maxClusters: number, CLUSTER_SIZE = 100): T[][]
{
	// we HAVE a list of groups of closely located points

	// we NEED a list of max 100-element clusters of points that are far from each other
	// we don't need more than maxClusters clusters
	// maxClusters is based on time period: no point in having more than ~15 clusters in a year or ~5 in a month

	// if there are less than 100 groups with N to M elements,
	// 	we just rotate indexes until we hit M or maxClusters clusters
	if (groups.length <= CLUSTER_SIZE)
		return equalSlice<T>(groups, maxClusters)

	// if there are more than 100 groups with N to M elements,
	// 	we just randomly sample 100 groups until some of them have no more elements
	//  but we don't actually randomly sample so just rotate by random number
	//  and it's not even random
	// groups.sort((a, b) => a.length - b.length) // sort by length ascending
	let clusters: T[][] = []
	let cluster: T[] = []
	let iterator = traverseBreadth(groups)
	for (let item of iterator)
	{
		cluster.push(item)
		if (cluster.length >= CLUSTER_SIZE)
		{
			clusters.push(cluster)
			cluster = []
		}
		if (clusters.length >= maxClusters)
			break
	}
	return clusters
}

function* traverseBreadth<T>(groups: T[][])
{
	let depth = 0
	let hasAny = true
	while (hasAny)
	{
		hasAny = false
		for (let i = 0; i < groups.length; i++)
		{
			let g = groups[i]
			if (depth >= g.length)
				continue

			hasAny = true

			yield g[depth]
		}
		depth++
	}
}

export function equalSlice<T>(groups: T[][], maxClusters: number)
{
	const maxGroupLength = groups.reduce((max, group) => Math.max(max, group.length), 0)
	const maxReturn = Math.min(maxGroupLength, maxClusters)

	const clusters: T[][] = []
	for (let i = 0; i < maxReturn; i++)
	{
		let c = []
		for (const group of groups)
			c.push(group[i % group.length])

		clusters.push(c)

		if (clusters.length >= maxClusters)
			break
	}
	return clusters
}

function addRootNode<T>(root: T, groups: T[][]): T[][]
{
	groups.forEach(group => group.unshift(root))
	return groups
}
